import React from 'react';
import './App.css';
import { HomePage } from './components/pages';

function App() {
  return <HomePage />;
}

export default App;
